import clsx from "clsx";
import React, { useEffect, useState } from "react";
import Amazon from "../icons/Amazon";
import BestBuy from "../icons/BestBuy";
import Brick from "../icons/Brick";
import CanadaComputers from "../icons/CanadaComputers";

const getLogo = (name) => {
    if (name === 'Amazon') {
        return <Amazon width={32} />
    } else if (name === 'Best Buy') {
        return <BestBuy width={32} />
    } else if (name === 'Brick') {
        return <Brick width={32} />
    } else if (name === 'Canada Computers') {
        return <CanadaComputers width={32} />
    }
}

export default function StoreLogo({ name }) {

    return getLogo(name)
}